import { useEffect, useRef } from "react";

const DEFAULT_KEYS = ["Escape"];

// Calls onClose when one of the given `KeyboardEvent.key` values is pressed.
export default function useCloseOnKey(
  onClose,
  keys = DEFAULT_KEYS,
  enabled = true,
) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  const keysSignature = (keys?.length ? keys : DEFAULT_KEYS).join("|");

  useEffect(() => {
    if (!enabled) return;

    const allowed = keysSignature.split("|");

    const handleKeyDown = (e) => {
      const key = e.key === "Esc" ? "Escape" : e.key;
      if (allowed.includes(key)) onCloseRef.current?.(e);
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [keysSignature, enabled]);
}
